export default __webpack_public_path__ + "static/media/nexen.6de3396d.svg";